import { inject } from '@angular/core';
import { ApiServerService, EmptyResponse } from '../../core/api';
import { PrintSettings } from '../../core/settings';

const baseUrl = 'uploads';

export type ProcessFileApiResponse = EmptyResponse;
export type UpdateThumbnailApiResponse = EmptyResponse;

export const injectUploadApi = () => {
  const service = inject(ApiServerService);
  return {
    processFile: (data: ProcessFileApiRequest): Promise<ProcessFileApiResponse> => {
      const path = `${baseUrl}/process/${data.uploadId}`;
      return service.call(path, data, 'files');
    },

    updateThumbnail: (data: UpdateThumbnailApiRequest): Promise<UpdateThumbnailApiResponse> => {
      const path = `${baseUrl}/thumbnail/${data.uploadId}`;
      return service.call(path, data, 'files');
    },
  };
};

export interface ProcessFileApiRequest {
  collection: string;
  uploadId: string;
  printSettings: PrintSettings;
  printAllowed?: boolean;
}

export interface UpdateThumbnailApiRequest {
  collection: string;
  uploadId: string;
  printSettings: PrintSettings;
  skipProductUpdate: boolean;
}
